// extracted by mini-css-extract-plugin
module.exports = {"pageBanner":"PageBanner_pageBanner__1xoVr","titleBanner":"PageBanner_titleBanner__2xSJ4"};